var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between py-2"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"\n\t\t\t\tself-center\n\t\t\t\tpl-2\n\t\t\t\tpr-2\n\t\t\t\trounded-full\n\t\t\t\tinline-flex\n\t\t\t\titems-center\n\t\t\t\ttext-pink\n\t\t\t\tfont-medium\n\t\t\t",class:{"text-pink": _vm.isTop, "text-blue": !_vm.isTop},style:({
				background: _vm.isTop
					? 'rgba(var(--vs-pink),.15)'
					: 'rgba(var(--vs-blue),.15)',
			})},[_vm._v("\n\t\t\t"+_vm._s(_vm.rating.toFixed(2))+"\n\t\t\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }